module.exports = __webpack_public_path__ + "img/beep_01.d59657b5.png";